(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slider = root.querySelector('[data-person-slider]');
    const output = root.querySelector('[data-person-count]');
    const people = root.querySelector('[data-people]');
    const icons = root.dataset.personIcons.split(',');
    function update() {
      const count = Number(slider.value);
      output.value = count;
      slider.setAttribute('aria-valuetext', `${count} ${count === 1 ? 'person' : 'people'}`);
      slider.style.setProperty('--progress', `${((count - 1) / 7) * 100}%`);
      people.replaceChildren(...Array.from({ length: count }, (_, i) => {
        const icon = document.createElement('img');
        icon.src = icons[i % icons.length];
        icon.alt = '';
        icon.width = 108;
        icon.height = 132;
        return icon;
      }));
    }
    slider.addEventListener('input', update);
    update();
  }
  document.querySelectorAll('[data-family-builder]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-family-builder]').forEach(init));
})();
